import { Component } from '@angular/core';

@Component({
  selector: 'app-tous-bn-recep',
  templateUrl: './tous-bn-recep.component.html',
  styleUrls: ['./tous-bn-recep.component.scss']
})
export class TousBnRecepComponent {}
